import type { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { getComplianceObjectsAction } from "./actions";
import type { ComplianceState } from "./types";

export function getComplianceObjectReducerBuilder(
  builder: ActionReducerMapBuilder<ComplianceState>,
) {
  builder.addCase(getComplianceObjectsAction.fulfilled, (state, action) => {
    if (!action.payload) return;
    const compliance = action.payload.reduce((acc, object) => {
      if (object.value.compliance) {
        return acc.concat(`${object.value.compliance} `);
      }
      return acc;
    }, "");
    state.compliance = `<security>${compliance.trim()}</security>`;
  });
}
